import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCustomThemeAdminFlag = lazyAfterPaint(
	() =>
		import(/* webpackChunkName: "async-custom-theme-admin-flag" */ './useCustomThemeAdminFlag.tsx'),
	{ ssr: false },
);

const AsyncCustomThemeAdminFlag = (): React.ReactNode => {
	const isSiteAdmin = useIsSiteAdmin();

	// Guard before rendering so non-admin users do not download this chunk and trigger unnecessary UFO holds.
	if (!isSiteAdmin && fg('perf-jsm-issue-view-ttai-custom-theme-admin-flag')) {
		return null;
	}

	return (
		<JSErrorBoundary id="async.jira.custom-theme-admin-flag" packageName="customThemeAdminFlag">
			<Placeholder name="custom-theme-admin-flag" fallback={null}>
				<LazyCustomThemeAdminFlag />
			</Placeholder>
		</JSErrorBoundary>
	);
};

export default AsyncCustomThemeAdminFlag;
